import React, { useEffect, useState } from 'react';
import { Layout, PageHeader, Row, Col, Spin } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import UserProfileList from './UserProfileList';
import { EnvironmentOutlined } from "@ant-design/icons";
import { WEBSITE_URL } from '../Helper';
import * as UserDataService from '../services/GetUserData';
import * as Actions from '../store/actions/user';

const { Content } = Layout;

const UserProfilePage = ({ profiles: propProfiles }) => {
  const dispatch = useDispatch();
  const reduxProfiles = useSelector((state) => state.User?.userDetails?.profiles || state.user?.userData?.profiles);
  const [loading, setLoading] = useState(false);
  const [profiles, setProfiles] = useState(propProfiles || reduxProfiles || []);

  useEffect(() => {
    if (propProfiles && propProfiles.length > 0) {
      setProfiles(propProfiles);
    } else if (reduxProfiles && reduxProfiles.length > 0) {
      setProfiles(reduxProfiles);
    } else {
      setLoading(true);
      dispatch(UserDataService.getUserData())
        .then((res) => {
          if (res) {
            dispatch(Actions.set_user_auth(res));
            if (res.profiles) {
              setProfiles(res.profiles);
            }
          }
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    }
  }, [propProfiles, reduxProfiles, dispatch]);

  const userRole = useSelector((state) => state.User?.userDetails?.user_role || state.user?.userData?.user_role);
  // Add New Location is strictly for inspector roles (um_inspector / ultimate / premium inspectors)
  const isInspectorRole = userRole === 'um_inspector' || userRole === 'um_flooring-inspector';
  const hasNonInspectorProfile = Array.isArray(profiles) && profiles.some((p) =>
    p.post_type === 'cleaning_restoration' ||
    p.post_type === 'consultant_profile' ||
    p.post_type === 'trusted_dealer' ||
    p.post_type === 'installer_profile'
  );
  const showAddLocation = isInspectorRole && !hasNonInspectorProfile;

  return (
    <Layout style={{ background: '#f8fafc', minHeight: '80vh' }}>
      <PageHeader title="User Profiles" />
      {showAddLocation && (
        <Row gutter={16} style={{ padding: '0 24px' }}>
          <Col xs={24} md={8} xl={4}>
            <div className='Purchasing-location-button'>
              <a id="Purchasing-Other-Location" className="profile-btn" href={`${WEBSITE_URL}/product/new-location/`}>
                Add New Location <EnvironmentOutlined />
              </a>
            </div>
          </Col>
        </Row>
      )}

      <Content style={{ padding: '24px' }}>
        {loading ? (
          <div style={{ textAlign: 'center', padding: '50px 0' }}>
            <Spin size="large" tip="Loading User Profiles..." />
          </div>
        ) : (
          <UserProfileList profiles={profiles} />
        )}
      </Content>
    </Layout>
  );
};

export default UserProfilePage;
